.r{overflow:hidden;}